import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  height: 500px;
  width: 100%;

  @media (max-width: 1600px) {
    height: 390px;
  }

  @media (max-width: 1200px) {
    height: 340px;
  }

  @media (max-width: 750px) {
    height: 280px;
  }
`
export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  max-height: 422px;
  width: 100%;
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;

  @media (max-width: 750px) {
    width: 70%;
  }
`
export const Image = styled.div<{ image: string; rotation: number }>`
  background-image: url('${({ image }) => image}');
  background-position: center;
  max-width: 100%;
  width: 420px;
  height: 420px;
  position: absolute;
  border-radius: 12px;
  transform: rotate(${({ rotation }) => rotation}deg);
  box-sizing: border-box;
  overflow: hidden;

  &:nth-child(1) {
    left: 0;
  }

  &:nth-child(2) {
    left: 0;
    right: 0;
    top: 40px;
    margin: auto;
  }

  &:nth-child(3) {
    right: 0;
  }

  @media (max-width: 1600px) {
    height: 320px;
    width: 320px;
  }

  @media (max-width: 1200px) {
    height: 280px;
    width: 280px;
  }

  @media (max-width: 1024px) {
    height: 260px;
    width: 260px;
  }

  @media (max-width: 750px) {
    left: 0;
    right: 0;
    margin: auto;

    &:nth-child(2) {
      top: 0;
    }
  }
`
